<main class="app_template_h__container" id="templateContainer">
  <app-print-header></app-print-header>
  <p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
    <ng-template pTemplate="header">
      <label><strong>Esops de exposición: </strong>
        {{ examen.esops?.length }}</label>
    </ng-template>
    <p-scrollPanel [style]="{ height: '200px' }">
      <p-table [value]="examen.esops">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%; text-align: center;">Código</th>
            <th style="width: 80%; text-align: center;">Concepto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="text-align: center;">{{ item.codigo }}</td>
            <td style="text-align: center;">{{ item.descripcion }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-scrollPanel>
    <p-footer>
      <p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
    </p-footer>
  </p-dialog>
  <!-- ------------------------------------------------inicio de formulario------------------------------------------------ -->

  <form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
    <div class="form-container p-fluid">

      <!-- ------------------------------------------------encabezado------------------------------------------------ -->
      <div class="p-grid p-jc-between" style="margin-bottom: 15px;">
        <div class="" style="display: flex;">
          <span>
            <i (click)="goBack()" class="pi pi-arrow-left"
              style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
          </span>
          <label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
        </div>

        <span class="print_hide-on-print">
          <app-print-button></app-print-button>
        </span>
      </div>
      <!-- ------------------------------------------------primer row (fecha)------------------------------------------------ -->
      <div class="p-grid">
        <div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
          <app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
          <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
            {{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
          </span>

          <p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
            [minDate]="minDate" class="print_hide-on-print"
            [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
            [disabled]="examen?.modoVista === 'ver'">
          </p-calendar>

          <app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid"></app-invalid-from-message>
        </div>

        <!-- NRO LOTE-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Lote"></app-fiel-title>
          <p class="readOnly">
            {{examen.lote.numeroLote}}
          </p>
        </div>

        <!-- NRO CARPETA-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Carpeta"></app-fiel-title>
          <p class="readOnly">
            {{examen.numeroCarpeta}}
          </p>
        </div>

        <div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
          <label class="color-text" (click)="displayAgentes = true">
            Esops de exposición ({{ examen.esops?.length }})</label>
        </div>
      </div>

      <!-- Seccion Empleador -->
      <div *ngIf="configForm.findSection('Empleador')">
        <div class="p-grid p-mt-2">
          <label class="p-title-seccion">
            {{ configForm.findNumberSection("Empleador") }}.Datos de la empresa
          </label>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Razón Social"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIT"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Establecimiento"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Teléfono"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Dirección de E-mail"></app-fiel-title>
            <p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Domicilio"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
          </div>
        </div>
      </div>

      <!-- Seccion Trabajador -->
      <div *ngIf="configForm.findSection('Trabajador')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Trabajador") }}.Datos Del Trabajador
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid p-grid-space">
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
              formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.apellidoNombre.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
								message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
							</app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIL"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.cuil}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
              (onSelect)="calculateAge()" (onBlur)="calculateAge()"
              [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
            </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="DNI"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.numeroDocumento}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Sexo"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.sexo}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Edad"></app-fiel-title>
            <p class="readOnly">
              {{ examen.trabajador.edad }} años
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}" alfanumericoDirective
              formControlName="puestoTrabajador" id="puesto" name="puesto" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.puestoTrabajador.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
              [disabled]="examen?.modoVista === 'ver'">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
              [disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
              [minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
              (onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
            </p-calendar>
            <app-invalid-from-message
              *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ----------------------------------3.Antecedentes Laborales ---------------------------------- -->
      <div *ngIf="configForm.findSection('Antecedentes Laborales')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Antecedentes Laborales") }}.Antecedentes Laborales
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-col-12 p-md-12">
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Describir la tarea que realiza" required="true"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.tarea.value.length > 0,
                'print_hide-on-print': f.tarea.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.tarea.value}}
              </p>
              <textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.tarea.invalid}"
                cols="30" formControlName="tarea" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
                [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.tarea.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="submitted && f.tarea.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.tarea.errors?.maxlength"
                message="Solo se permiten {{ f.tarea.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Cuanto tiempo desarrolla la tarea" required="true"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.tiempoTarea.value.length > 0,
                'print_hide-on-print': f.tiempoTarea.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.tiempoTarea.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.tiempoTarea.invalid}" cols="30"
                formControlName="tiempoTarea" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
                [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.tiempoTarea.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="submitted && f.tiempoTarea.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.tiempoTarea.errors?.maxlength"
                message="Solo se permiten {{ f.tiempoTarea.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-8 print_dont_break">
              <app-fiel-title label="Criterios de Exposición" required="true"></app-fiel-title>
              <div style="display: flex;">
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                      && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value
                      && !f.bipedestacionNingunaAnteriores.value}" (onChange)="f.bipedestacionNingunaAnteriores.setValue(false)"
                      formControlName="sintomasPrevio2014" inputId="sintomasPrevio2014"
                      label="Comienzo de síntomas previo al 2014" name="sintomasPrevio2014"
                      [ngModel]="examen.sintomasPrevio2014 === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                      && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value
                      && !f.bipedestacionNingunaAnteriores.value}" (onChange)="f.bipedestacionNingunaAnteriores.setValue(false)"
                      formControlName="bipedestacionCarga" inputId="bipedestacionCarga" label="Bipedestación con carga"
                      name="bipedestacionCarga" [ngModel]="examen.bipedestacionCarga === true"
                      [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                      && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value
                      && !f.bipedestacionNingunaAnteriores.value}" (onChange)="f.bipedestacionNingunaAnteriores.setValue(false)"
                      formControlName="bipedestacionEstatica" inputId="bipedestacionEstatica"
                      label="Bipedestación estática por lo menos durante dos horas" name="bipedestacionEstatica"
                      [ngModel]="examen.bipedestacionEstatica === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                      && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value
                      && !f.bipedestacionNingunaAnteriores.value}" (onChange)="f.bipedestacionNingunaAnteriores.setValue(false)"
                      formControlName="bipedestacionRestringida" inputId="bipedestacionRestringida"
                      label="Bipedestación restringida (menos de 100 metros por al menos 3 hs)"
                      name="bipedestacionRestringida " [ngModel]="examen.bipedestacionRestringida === true"
                      [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
                <div class="p-md-4">
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                      && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value
                      && !f.bipedestacionNingunaAnteriores.value}" (onChange)="f.bipedestacionNingunaAnteriores.setValue(false)"
                      formControlName="bipedestacionExposicion" inputId="bipedestacionExposicion"
                      label="Bipedestación con exposición a carga térmica (al menos dos horas)"
                      name="bipedestacionExposicion" [ngModel]="examen.bipedestacionExposicion === true"
                      [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                  <div class="p-field-checkbox">
                    <p-checkbox binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                      && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value && !f.bipedestacionNingunaAnteriores.value}"
                      [ngModel]="!examen.sintomasPrevio2014 && !examen.bipedestacionCarga && !examen.bipedestacionEstatica && !examen.bipedestacionRestringida
                      && !examen.bipedestacionExposicion"
                      formControlName="bipedestacionNingunaAnteriores" inputId="bipedestacionNingunaAnteriores"
                      label="Ninguna de las anteriores" (onChange)="clickCheckBox('ningunaAnteriores', $event)"
                      name="bipedestacionNingunaAnteriores" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </div>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted &&!f.bipedestacionEstatica.value && !f.bipedestacionRestringida.value
                && !f.bipedestacionCarga.value && !f.bipedestacionExposicion.value && !f.sintomasPrevio2014.value && !f.bipedestacionNingunaAnteriores.value">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title
                label="Síntomas que refiere (dolores, prurito, sensación de pesadez en piernas, calambres, etc.)"
                required="true"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.sintomasRefiere.value.length > 0,
                'print_hide-on-print': f.sintomasRefiere.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.sintomasRefiere.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.sintomasRefiere.invalid}" cols="30"
                formControlName="sintomasRefiere" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
                [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.sintomasRefiere.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="submitted && f.sintomasRefiere.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.sintomasRefiere.errors?.maxlength"
                message="Solo se permiten {{ f.sintomasRefiere.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
      </div>

      <!-- ----------------------------------3.Antecedentes Personales ---------------------------------- -->
      <div *ngIf="configForm.findSection('Antecedentes Personales')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Antecedentes Personales") }}.Antecedentes Personales
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <!--Campos Peso Talla IMC-->
          <div class="p-field p-col-12 p-md-4 print_dont_break">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <app-fiel-title label="Peso" required="true"></app-fiel-title>
              <i class="pi pi-question-circle" 
                 style="font-size: 0.9rem; color: #6c757d; cursor: help;"
                 pTooltip="Valores permitidos: 40 a 180 kg" 
                 tooltipPosition="right"></i>
            </div>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.peso.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': (submitted || imcValidationTriggered) && f.peso.invalid}"
              formControlName="peso" id="peso" [minFractionDigits]="2" [maxFractionDigits]="2" name="peso"
              [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <div style="min-height: 42px;">
              <app-invalid-from-message *ngIf="(submitted || imcValidationTriggered) && f.peso.errors?.required"></app-invalid-from-message>
              <app-invalid-from-message *ngIf="(submitted || imcValidationTriggered) && (f.peso.errors?.min || f.peso.errors?.max)"
                message="Solo se permiten valores entre 40 y 180"></app-invalid-from-message>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4 print_dont_break">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <app-fiel-title label="Talla" required="true"></app-fiel-title>
              <i class="pi pi-question-circle" 
                 style="font-size: 0.9rem; color: #6c757d; cursor: help;"
                 pTooltip="Valores permitidos: 100 a 220 cm" 
                 tooltipPosition="right"></i>
            </div>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.talla.value}}
            </span>
            <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': (submitted || imcValidationTriggered) && f.talla.invalid}"
              formControlName="talla" id="talla" name="talla" maxlength="3"
              [disabled]="examen?.modoVista === 'ver'">
            </p-inputNumber>
            <div style="min-height: 42px;">
              <app-invalid-from-message *ngIf="(submitted || imcValidationTriggered) && f.talla.errors?.required"></app-invalid-from-message>
              <app-invalid-from-message *ngIf="(submitted || imcValidationTriggered) && (f.talla.errors?.min || f.talla.errors?.max)"
                message="Solo se permiten valores entre 100 y 220"></app-invalid-from-message>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4 print_dont_break">
            <app-fiel-title label="IMC" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{f.indiceMasaCorporal.value}}
            </span>
            <div style="display: flex; flex-wrap: wrap; margin-right: -0.5rem; margin-left: -0.5rem;">
              <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                <p-inputNumber class="print_hide-on-print"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.indiceMasaCorporal.invalid}"
                  formControlName="indiceMasaCorporal" 
                  id="indiceMasaCorporal" 
                  name="indiceMasaCorporal"
                  [readonly]="true"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-inputNumber>
                <div style="min-height: 42px;">
                  <app-invalid-from-message *ngIf="submitted && f.indiceMasaCorporal.errors?.required && (!f.talla.invalid && !f.peso.invalid)"
                      message="Debe calcular el IMC">
                  </app-invalid-from-message>
                </div>
              </div>
              <div class="p-col-12 p-md-6 print_hide-on-print" style="display: flex; align-items: flex-start;">
                <button [disabled]="examen?.modoVista === 'ver' ? true : null" 
                        pButton pRipple 
                        type="button"
                        label="Calcular IMC" 
                        (click)="calcularImc()"
                        style="width: 100%;"></button>
              </div>
            </div>
            <app-invalid-from-message
              *ngIf="submitted && f.indiceMasaCorporal.errors?.required"></app-invalid-from-message>
          </div>
          <div class="p-col-12 p-md-12">
            <!--Campo Tabaquismo-->
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Tabaquismo" required="true"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('noFumador', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value}"
                    formControlName="noFumador" inputId="noFumador" label="No Fuma" name="noFumador"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('fumador', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value}"
                    formControlName="fumador" inputId="fumador" label="Fuma" name="fumador"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('exFumador', $event)" binary="true"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value}"
                    formControlName="exFumador" inputId="exFumador" label="Ex Fumador" name="exFumador"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <app-invalid-from-message
                *ngIf="submitted && !f.noFumador.value && !f.fumador.value && !f.exFumador.value"></app-invalid-from-message>
            </div>
            <!--Campo Tabaquismo Cantidad-->
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Cantidad de cigarrillos"></app-fiel-title>
              <div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;" [ngClass]="{'ng-invalid ng-dirty': submitted &&
              !f.fumaUnoDiez.value && !f.fumador.value && !f.exFumador.value}">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('fumaUnoDiez', $event)" binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value &&
                  !f.fumaOnceVeinte.value && !f.fumaMasVeinte.value}" formControlName="fumaUnoDiez"
                    inputId="fumaUnoDiez" label="1 a 10 cigarrillos" name="fumaUnoDiez"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('fumaOnceVeinte', $event)" binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value &&
                  !f.fumaOnceVeinte.value && !f.fumaMasVeinte.value}" formControlName="fumaOnceVeinte"
                    inputId="fumaOnceVeinte" label="11 a 20 cigarrillos" name="fumaOnceVeinte"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="clickCheckBox('fumaMasVeinte', $event)" binary="true" [ngClass]="{'ng-invalid ng-dirty': submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value &&
                  !f.fumaOnceVeinte.value && !f.fumaMasVeinte.value}" formControlName="fumaMasVeinte"
                    inputId="fumaMasVeinte" label="Más de 20 cigarrillos" name="fumaMasVeinte"
                    [disabled]="examen?.modoVista === 'ver'">
                  </p-checkbox>
                </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && (f.fumador.value || f.exFumador.value) && !f.fumaUnoDiez.value && !f.fumaOnceVeinte.value
              && !f.fumaMasVeinte.value"></app-invalid-from-message>
            </div>
            <div class="p-field p-col-12 p-md-12 print_dont_break">
              <app-fiel-title *ngIf="!f.exFumador.value" label="Hace cuánto tiempo fuma"></app-fiel-title>
              <app-fiel-title *ngIf="f.exFumador.value" label="Hace cuánto dejó de fumar"></app-fiel-title>
              <div style="display: flex; flex-direction: row; align-items: center;">
                <div class="p-col-12 p-md-2" style="padding-left: 0;">
                  <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                    {{f.cantidadTiempoFumando.value}} {{f.unidadTiempoFumando.value}}
                  </span>
                  <p-inputNumber class="print_hide-on-print"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.cantidadTiempoFumando.invalid}"
                    formControlName="cantidadTiempoFumando" id="cantidadTiempoFumando" name="cantidadTiempoFumando"
                    [disabled]="examen?.modoVista === 'ver'" maxlength="4" [useGrouping]="false">
                  </p-inputNumber>
                </div>
                <div class="p-col-12 p-md-2">
                  <p-dropdown class="print_hide-on-print"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.unidadTiempoFumando.invalid}"
                    [options]="unidadesTiempoTabaquismo" formControlName="unidadTiempoFumando" placeholder="Seleccione"
                    optionLabel="label" optionValue="value" [showClear]="true" [disabled]="examen?.modoVista === 'ver'">
                  </p-dropdown>
                </div>
              </div>
              <app-invalid-from-message
                *ngIf="submitted && (f.cantidadTiempoFumando.invalid || f.unidadTiempoFumando.invalid)"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Afecciones cardiovasculares (Hipertensión, Cardiopatías, Otras)"
                required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesCardiovasculares.invalid }">
                <p-radioButton (onClick)="clickRadioButton('SI', 'CARDIOVASCULARES')" name="afeccionesCardiovasculares"
                  [value]="true" formControlName="afeccionesCardiovasculares" label="Si"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesCardiovasculares.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton (onClick)="clickRadioButton('NO', 'CARDIOVASCULARES')" name="afeccionesCardiovasculares"
                  [value]="false" formControlName="afeccionesCardiovasculares" label="No"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesCardiovasculares.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message
                *ngIf="submitted && f.afeccionesCardiovasculares.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_row-full print_dont_break">
              <app-fiel-title label="Describa"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.afeccionesCardiovascularesDescripcion.value.length > 0,
              'print_hide-on-print': f.afeccionesCardiovascularesDescripcion.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.afeccionesCardiovascularesDescripcion.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesCardiovascularesDescripcion.invalid}"
                cols="30" formControlName="afeccionesCardiovascularesDescripcion" id="result" maxlength="250"
                name="resul" pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            </textarea>
              <small style="text-align: end;">
                {{ f.afeccionesCardiovascularesDescripcion.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="submitted && f.afeccionesCardiovascularesDescripcion.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.afeccionesCardiovascularesDescripcion.errors?.maxlength"
                message="Solo se permiten {{ f.afeccionesCardiovascularesDescripcion.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Afecciones metabólicas (Diabetes, Síndrome metabólico, dislipemias)"
                required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesMetabolicas.invalid }">
                <p-radioButton (onClick)="clickRadioButton('SI', 'METABOLICAS')" name="afeccionesMetabolicas"
                  [value]="true" formControlName="afeccionesMetabolicas" label="Si"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesMetabolicas.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton (onClick)="clickRadioButton('NO', 'METABOLICAS')" name="afeccionesMetabolicas"
                  [value]="false" formControlName="afeccionesMetabolicas" label="No"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesMetabolicas.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.afeccionesMetabolicas.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Describa"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.afeccionesMetabolicasDescripcion.value.length > 0,
                'print_hide-on-print': f.afeccionesMetabolicasDescripcion.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.afeccionesMetabolicasDescripcion.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.afeccionesMetabolicasDescripcion.invalid}" cols="30"
                formControlName="afeccionesMetabolicasDescripcion" id="result" maxlength="250" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
              </textarea>
              <small style="text-align: end;">
                {{ f.afeccionesMetabolicasDescripcion.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="submitted && f.afeccionesMetabolicasDescripcion.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.afeccionesMetabolicasDescripcion.errors?.maxlength"
                message="Solo se permiten {{ f.afeccionesMetabolicasDescripcion.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Toma de anticonceptivos orales" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.anticonceptivosOrales.invalid }">
                <p-radioButton name="anticonceptivosOrales" [value]="true" formControlName="anticonceptivosOrales"
                  label="Si" [ngClass]="{'ng-invalid ng-dirty': submitted && f.anticonceptivosOrales.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton name="anticonceptivosOrales" [value]="false" formControlName="anticonceptivosOrales"
                  label="No" [ngClass]="{'ng-invalid ng-dirty': submitted && f.anticonceptivosOrales.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.anticonceptivosOrales.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-12 print_dont_break">
              <app-fiel-title label="Embarazos" required="true"></app-fiel-title>
              <div style="display: flex; flex-direction: row;"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.embarazos.invalid }">
                <p-radioButton name="embarazos" [value]="true" formControlName="embarazos" label="Si"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.embarazos.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
                <p-radioButton name="embarazos" [value]="false" formControlName="embarazos" label="No"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.embarazos.invalid}"
                  [disabled]="examen?.modoVista === 'ver'">
                </p-radioButton>
              </div>
              <app-invalid-from-message *ngIf="submitted && f.embarazos.invalid"></app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Antecedentes familiares de varicopatía" required="true"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.antecedentesFamiliaresVaricopatia.value.length > 0,
                  'print_hide-on-print': f.antecedentesFamiliaresVaricopatia.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.antecedentesFamiliaresVaricopatia.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesFamiliaresVaricopatia.invalid}" cols="30"
                formControlName="antecedentesFamiliaresVaricopatia" id="result" maxlength="250" name="resul"
                pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
                </textarea>
              <small style="text-align: end;">
                {{ f.antecedentesFamiliaresVaricopatia.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="submitted && f.antecedentesFamiliaresVaricopatia.errors?.required">
              </app-invalid-from-message>
              <app-invalid-from-message *ngIf="f.antecedentesFamiliaresVaricopatia.errors?.maxlength"
                message="Solo se permiten {{ f.antecedentesFamiliaresVaricopatia.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
            <div class="p-col-12 p-md-6 print_dont_break">
              <app-fiel-title label="Tratamiento médico actual"></app-fiel-title>
              <p [ngClass]="{'print_show-on-print': f.tratamientoMedicoActual.value.length > 0,
                  'print_hide-on-print': f.tratamientoMedicoActual.value.length < 1}"
                class="print_hidden-area-before-print print_row-full p-field-word-break">
                {{f.tratamientoMedicoActual.value}}
              </p>
              <textarea class="print_hide-on-print"
                [ngClass]="{'ng-invalid ng-dirty': submitted && f.tratamientoMedicoActual.invalid}" cols="30"
                formControlName="tratamientoMedicoActual" id="result" maxlength="250" name="resul" pInputTextarea
                rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
                </textarea>
              <small style="text-align: end;">
                {{ f.tratamientoMedicoActual.value.length }}/250
              </small>
              <app-invalid-from-message *ngIf="f.tratamientoMedicoActual.errors?.maxlength"
                message="Solo se permiten {{ f.tratamientoMedicoActual.errors.maxlength.requiredLength  }} caracteres">
              </app-invalid-from-message>
            </div>
          </div>
        </div>
      </div>

      <!-- ----------------------------------3.Examen Clínico ---------------------------------- -->
      <div *ngIf="configForm.findSection('Examen Clínico')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Examen Clínico") }}.Examen Clínico
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-col-12 p-md-12 p-pb-0 print_dont_break">
            <div style="display: flex; flex-wrap: wrap;">
              <div class="p-col-6 p-md-4 p-pt-0 p-pl-0 p-pb-0">
                <app-fiel-title label="Antecedentes de várices" required="true"></app-fiel-title>
              </div>
              <div class="p-col-4 p-md-4 p-pt-0 p-pb-0 print_hide-on-print">
                <app-fiel-title label="Año"></app-fiel-title>
              </div>
            </div>
            <div class="p-col-12 p-md-12 p-p-0" style="display: flex; flex-direction: row; align-items: center;">
              <div class="p-col-4 p-md-2">
                <div style="display: flex; flex-direction: row;"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesVarices.invalid }">
                  <p-radioButton name="antecedentesVarices" [value]="true" formControlName="antecedentesVarices" label="Si"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesVarices.invalid}"
                    [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'VARICES')"
                    [ngModel]="examen.antecedentesVarices">
                  </p-radioButton>
                  <p-radioButton name="antecedentesVarices" [value]="false" formControlName="antecedentesVarices" label="No"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesVarices.invalid}"
                    [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'VARICES')"
                    [ngModel]="examen.antecedentesVarices">
                  </p-radioButton>
                </div>
                <app-invalid-from-message *ngIf="submitted && f.antecedentesVarices.invalid"></app-invalid-from-message>
              </div>
              <div class="p-col-2 p-md-2">
                <p-checkbox (onChange)="clickCheckBox('varicesOperada', $event)" binary="true"
                  formControlName="antecedentesVaricesOperada" inputId="antecedentesVaricesOperada" label="Operada"
                  name="antecedentesVaricesOperada" [disabled]="examen?.modoVista === 'ver'"
                  [ngModel]="examen.antecedentesVaricesOperada === true">
                </p-checkbox>
              </div>
              <div class="p-field p-col-4 p-md-2 p-mb-0">
                <app-fiel-title label="Año" class="print_edadInputNumber_hide print_show-on-print"></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.antecedentesVaricesAnio.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.antecedentesVaricesAnio.invalid}"
                  formControlName="antecedentesVaricesAnio" id="antecedentesVaricesAnio" name="antecedentesVaricesAnio" maxlength="4"
                  [disabled]="examen?.modoVista === 'ver'" [useGrouping]="false">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.antecedentesVaricesAnio.errors?.required"></app-invalid-from-message>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-12 p-pb-0 print_dont_break">
            <div style="display: flex; flex-wrap: wrap;">
              <div class="p-col-6 p-md-4 p-pt-0 p-pl-0 p-pb-0">
                <app-fiel-title label="Varicocele" required="true"></app-fiel-title>
              </div>
              <div class="p-col-4 p-md-4 p-pt-0 p-pb-0 print_hide-on-print">
                <app-fiel-title label="Año"></app-fiel-title>
              </div>
            </div>
            <div class="p-col-12 p-md-12 p-p-0" style="display: flex; flex-direction: row; align-items: center;">
              <div class="p-col-4 p-md-2">
                <div style="display: flex; flex-direction: row;"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.varicocele.invalid }">
                  <p-radioButton name="varicocele" [value]="true" formControlName="varicocele" label="Si"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.varicocele.invalid}"
                    [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'VARICOCELE')"
                    [ngModel]="examen.varicocele">
                  </p-radioButton>
                  <p-radioButton name="varicocele" [value]="false" formControlName="varicocele" label="No"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.varicocele.invalid}"
                    [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'VARICOCELE')"
                    [ngModel]="examen.varicocele">
                  </p-radioButton>
                </div>
                <app-invalid-from-message *ngIf="submitted && f.varicocele.invalid"></app-invalid-from-message>
              </div>
              <div class="p-col-2 p-md-2">
                <p-checkbox (onChange)="clickCheckBox('varicoceleOperada', $event)" binary="true"
                  formControlName="varicoceleOperada" inputId="varicoceleOperada" label="Operada"
                  name="varicoceleOperada" [disabled]="examen?.modoVista === 'ver'"
                  [ngModel]="examen.varicoceleOperada === true">
                </p-checkbox>
              </div>
              <div class="p-field p-col-4 p-md-2 p-mb-0">
                <app-fiel-title label="Año" class="print_edadInputNumber_hide print_show-on-print"></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.varicoceleAnio.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.varicoceleAnio.invalid}"
                  formControlName="varicoceleAnio" id="varicoceleAnio" name="varicoceleAnio" maxlength="4"
                  [disabled]="examen?.modoVista === 'ver'" [useGrouping]="false">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.varicoceleAnio.errors?.required"></app-invalid-from-message>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-12 p-pb-0 print_dont_break">
            <div style="display: flex; flex-wrap: wrap;">
              <div class="p-col-6 p-md-4 p-pt-0 p-pl-0 p-pb-0">
                <app-fiel-title label="Hemorroides" required="true"></app-fiel-title>
              </div>
              <div class="p-col-4 p-md-4 p-pt-0 p-pb-0 print_hide-on-print">
                <app-fiel-title label="Año"></app-fiel-title>
              </div>
            </div>
            <div class="p-col-12 p-md-12 p-p-0" style="display: flex; flex-direction: row; align-items: center;">
              <div class="p-col-4 p-md-2">
                <div style="display: flex; flex-direction: row;"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.hemorroides.invalid }">
                  <p-radioButton name="hemorroides" [value]="true" formControlName="hemorroides" label="Si"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.hemorroides.invalid}"
                    [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('SI', 'HEMORROIDES')"
                    [ngModel]="examen.hemorroides">
                  </p-radioButton>
                  <p-radioButton name="hemorroides" [value]="false" formControlName="hemorroides" label="No"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && f.hemorroides.invalid}"
                    [disabled]="examen?.modoVista === 'ver'" (onClick)="clickRadioButton('NO', 'HEMORROIDES')"
                    [ngModel]="examen.hemorroides">
                  </p-radioButton>
                </div>
                <app-invalid-from-message *ngIf="submitted && f.hemorroides.invalid"></app-invalid-from-message>
              </div>
              <div class="p-col-2 p-md-2">
                <p-checkbox (onChange)="clickCheckBox('hemorroidesOperada', $event)" binary="true"
                  formControlName="hemorroidesOperada" inputId="hemorroidesOperada" label="Operada"
                  name="hemorroidesOperada" [disabled]="examen?.modoVista === 'ver'"
                  [ngModel]="examen.hemorroidesOperada === true">
                </p-checkbox>
              </div>
              <div class="p-field p-col-4 p-md-2 p-mb-0">
                <app-fiel-title label="Año" class="print_edadInputNumber_hide print_show-on-print"></app-fiel-title>
                <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
                  {{f.hemorroidesAnio.value}}
                </span>
                <p-inputNumber class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.hemorroidesAnio.invalid}"
                  formControlName="hemorroidesAnio" id="hemorroidesAnio" name="hemorroidesAnio" maxlength="4"
                  [disabled]="examen?.modoVista === 'ver'" [useGrouping]="false">
                </p-inputNumber>
                <app-invalid-from-message *ngIf="submitted && f.hemorroidesAnio.errors?.required"></app-invalid-from-message>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-6">
            <app-fiel-title label="Exámen Clínico" required="true"></app-fiel-title>
            <table class="p-datatable-solid enabled">
              <thead>
                <tr>
                  <th class="no-border-cell"></th>
                  <th class="no-border-cell"></th>
                  <th>M.izq</th>
                  <th>M.der</th>
                  <th>Bilateral</th>
                  <th>A</th>
                  <th>S</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>C0</td>
                  <td>Sin signo visible o palpable de enfermedad venosa</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0mizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c0mizq" inputId="c0mizq" label="" name="c0mizq"
                      [ngModel]="examen.c0mizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0mder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c0mder" inputId="c0mder" label="" name="c0mder"
                      [ngModel]="examen.c0mder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0bilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c0bilateral" inputId="c0bilateral" label="" name="c0bilateral"
                      [ngModel]="examen.c0bilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c0asintomatico" inputId="c0asintomatico" label="" name="c0asintomatico"
                      [ngModel]="examen.c0asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c0sintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c0sintomatico" inputId="c0sintomatico" label="" name="c0sintomatico"
                      [ngModel]="examen.c0sintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C1</td>
                  <td>Telangiectasias o venas reticulares</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1mizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c1mizq" inputId="c1mizq" label="" name="c1mizq"
                      [ngModel]="examen.c1mizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1mder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c1mder" inputId="c1mder" label="" name="c1mder"
                      [ngModel]="examen.c1mder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1bilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c1bilateral" inputId="c1bilateral" label="" name="c1bilateral"
                      [ngModel]="examen.c1bilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c1asintomatico" inputId="c1asintomatico" label="" name="c1asintomatico"
                      [ngModel]="examen.c1asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c1sintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c1sintomatico" inputId="c1sintomatico" label="" name="c1sintomatico"
                      [ngModel]="examen.c1sintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C2</td>
                  <td>Venas varicosas, Se diferencian de las venas reticulares en que su diámetro es igual o superior a 3 mm.</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2mizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c2mizq" inputId="c2mizq" label="" name="c2mizq"
                      [ngModel]="examen.c2mizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2mder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c2mder" inputId="c2mder" label="" name="c2mder"
                      [ngModel]="examen.c2mder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2bilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c2bilateral" inputId="c2bilateral" label="" name="c2bilateral"
                      [ngModel]="examen.c2bilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c2asintomatico" inputId="c2asintomatico" label="" name="c2asintomatico"
                      [ngModel]="examen.c2asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c2sintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c2sintomatico" inputId="c2sintomatico" label="" name="c2sintomatico"
                      [ngModel]="examen.c2sintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C3</td>
                  <td>Edema</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3mizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c3mizq" inputId="c3mizq" label="" name="c3mizq"
                      [ngModel]="examen.c3mizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3mder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c3mder" inputId="c3mder" label="" name="c3mder"
                      [ngModel]="examen.c3mder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3bilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c3bilateral" inputId="c3bilateral" label="" name="c3bilateral"
                      [ngModel]="examen.c3bilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c3asintomatico" inputId="c3asintomatico" label="" name="c3asintomatico"
                      [ngModel]="examen.c3asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c3sintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c3sintomatico" inputId="c3sintomatico" label="" name="c3sintomatico"
                      [ngModel]="examen.c3sintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C4a</td>
                  <td>Enfermedad venosa crónica, c/pigmentación y/o eczema venoso</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4amizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4amizq" inputId="c4amizq" label="" name="c4amizq"
                      [ngModel]="examen.c4amizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4amder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4amder" inputId="c4amder" label="" name="c4amder"
                      [ngModel]="examen.c4amder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4abilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4abilateral" inputId="c4abilateral" label="" name="c4abilateral"
                      [ngModel]="examen.c4abilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4aasintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4aasintomatico" inputId="c4aasintomatico" label="" name="c4aasintomatico"
                      [ngModel]="examen.c4aasintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4asintomatico" inputId="c4asintomatico" label="" name="c4asintomatico"
                      [ngModel]="examen.c4asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C4b</td>
                  <td>Enfermedad venosa crónica, con celulitis indurada y/o atrofia blanca</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bmizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4bmizq" inputId="c4bmizq" label="" name="c4bmizq"
                      [ngModel]="examen.c4bmizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bmder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4bmder" inputId="c4bmder" label="" name="c4bmder"
                      [ngModel]="examen.c4bmder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bbilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4bbilateral" inputId="c4bbilateral" label="" name="c4bbilateral"
                      [ngModel]="examen.c4bbilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4basintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4basintomatico" inputId="c4basintomatico" label="" name="c4basintomatico"
                      [ngModel]="examen.c4basintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c4bsintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c4bsintomatico" inputId="c4bsintomatico" label="" name="c4bsintomatico"
                      [ngModel]="examen.c4bsintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C5</td>
                  <td>Úlcera cicatrizada</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5mizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c5mizq" inputId="c5mizq" label="" name="c5mizq"
                      [ngModel]="examen.c5mizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5mder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c5mder" inputId="c5mder" label="" name="c5mder"
                      [ngModel]="examen.c5mder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5bilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c5bilateral" inputId="c5bilateral" label="" name="c5bilateral"
                      [ngModel]="examen.c5bilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c5asintomatico" inputId="c5asintomatico" label="" name="c5asintomatico"
                      [ngModel]="examen.c5asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c5sintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c5sintomatico" inputId="c5sintomatico" label="" name="c5sintomatico"
                      [ngModel]="examen.c5sintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>C6</td>
                  <td>Úlcera no cicatrizada</td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6mizq', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c6mizq" inputId="c6mizq" label="" name="c6mizq"
                      [ngModel]="examen.c6mizq === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6mder', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c6mder" inputId="c6mder" label="" name="c6mder"
                      [ngModel]="examen.c6mder === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6bilateral', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c6bilateral" inputId="c6bilateral" label="" name="c6bilateral"
                      [ngModel]="examen.c6bilateral === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6asintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c6asintomatico" inputId="c6asintomatico" label="" name="c6asintomatico"
                      [ngModel]="examen.c6asintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                  <td>
                    <p-checkbox class="tableVarices" (onChange)="clickTableVarices('c6sintomatico', $event.checked)" binary="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && cuadroVaricesInvalid}"
                      formControlName="c6sintomatico" inputId="c6sintomatico" label="" name="c6sintomatico"
                      [ngModel]="examen.c6sintomatico === true" [disabled]="examen?.modoVista === 'ver'">
                    </p-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="p-col-12 p-md-6 p-pl-0 print_hide-on-print">
              <button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button"
                label="Limpiar cuadro várices" (click)="limpiarCuadroVarices()"></button>
            </div>
            <p class="p-mt-0">Cada Clase se debe completar con: (A)Asintomática, (s)Sintomática. Los síntomas escogidos son los dolores, el purito,
              la sensación de pesadez de las piernas, los calambres y todos los síntomas que puedan atribuirse a una insuficiencia venosa.
            </p>
            <app-invalid-from-message *ngIf="submitted && cuadroVaricesInvalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!--Seccion Dictamen medico-->
      <div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Dictamen medico") }}.Dictamen médico
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <!--Campo Tipo Dictamen-->
          <div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

              <div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

                <p-radioButton name="codigoDictamen" [value]="item.codigo" formControlName="codigoDictamen"
                  label="{{ item.descripcion }}"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
                </p-radioButton>

              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Especialidades-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Especialidad" required="true"></app-fiel-title>
            <p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
              [options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
              optionLabel="descripcion" optionValue="codigo" [showClear]="true"
              [disabled]="examen?.modoVista === 'ver'">
            </p-dropdown>
            <app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Médico-->
          <div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Médico" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}" alfanumericoDirective
              formControlName="medicoNombre" id="medico" name="medico" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Matricula-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Matrícula" required="true"></app-fiel-title>
            <!-- Modificar para validar el formato de la matricula -->
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.matricula.invalid}" numberDirective
              formControlName="matricula" id="matricula" name="matricula" maxlength="18" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.matricula.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-form-footer">
          <div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
            <button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar"
              (click)="showModalFirma()"></button>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ------------ ADJUNTAR ARCHIVO ------------ -->
      <div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Adjuntos") }}.Archivos adjuntos
          <strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
          <span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
            {{ attachedFiles.attachedFilesValidQuantity }}
          </span>
        </label>
        <p-divider></p-divider>

        <app-attach-upload-file [examenNumero]="this.examen?.id" [isRequire]="configForm.isAttachedFileRequire"
          (filesAttachedData)="getAttachedFiles($event)" [attachedFilesFromBackend]="this.examen?.attachments"
          [viewMode]="this.examen?.modoVista" [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
        </app-attach-upload-file>

        <app-attached-file-mandatory-message
          *ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
        </app-attached-file-mandatory-message>
      </div>
      <!-- ------------------------------------------------footer botones------------------------------------------------ -->
      <div class="p-grid p-form-footer">
        <div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
          <ng-container *ngIf="examen?.modoVista === 'ver'">
            <button pButton pRipple type="button" label="Volver" class="p-button-text" (click)="goBack()"></button>
          </ng-container>

          <ng-container *ngIf="examen?.modoVista !== 'ver'">
            <button pButton pRipple type="button" label="Cancelar" class="p-button-text" (click)="goBack()"></button>
            <p-button type="submit" label="Guardar" *ngIf="!enviandose"
              [disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
            </p-button>
            <p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
          </ng-container>
        </div>
      </div>

      <app-print-footer [firmaB64]="examen?.firmaB64" [medicoFirmaB64]="medicoFirmaB64"
        [trabajadorApellidoNombre]="f.apellidoNombre.value" [medicoNombre]="f.medicoNombre?.value"
        [medicoEspecialidad]="f.medicoEspecialidad.value" [medicoMatricula]="f.matricula?.value">
      </app-print-footer>

    </div>
  </form>

  <p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormEC" styleClass="p-dialog-custom">
    <p-footer>
      <button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton type="button"></button>
      <button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
    </p-footer>

  </p-confirmDialog>
</main>

<section id="modal-firma">
  <app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma"
    (closeModal)="closeModalFirma()"></app-topaz>
</section>
